import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { StateRxService } from '../../services/staterx.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'hcf-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PopupComponent implements OnDestroy {
  showPopup: boolean = false;

  private _subscriptionEscPressed: Subscription;
  private _subscriptionClosePopup: Subscription;

  constructor(
    _stateRx: StateRxService,
    private _uiService: UiService,
  ) {
    this._subscriptionEscPressed = _stateRx.escPressed.rxSubscribe(() => {
      this.closePopup();
    });

    this._subscriptionClosePopup = _stateRx.closePopup.rxSubscribe(() => {
      this.closePopup();
    });
  }

  openPopup() {
    this.showPopup = true;
    this._uiService.scrollToTop();
  }

  closePopup() {
    this.showPopup = false;
  }

  ngOnDestroy() {
    this._subscriptionEscPressed.unsubscribe();
    this._subscriptionClosePopup.unsubscribe();
  }
}
